'use client';

import { useEffect } from 'react';
import { ensureGoogleEventQueue } from '../../lib/analytics/google';

export default function GoogleTagManager() {
  useEffect(() => {
    let gtmDidInit = false;

    const initGTM = () => {
      if (gtmDidInit) {
        return;
      }

      gtmDidInit = true;

      ensureGoogleEventQueue();

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=G-BR7KM2J62S`;
      script.onerror = () => {
        console.error('Failed to load gtag.js');
      };

      document.head.appendChild(script);
    };

    const initGTMOnEvent = () => {
      initGTM();
    };

    // Interaction still wins, but an idle fallback guarantees that passive visits
    // and search-engine landing sessions are measured too.
    document.addEventListener('scroll', initGTMOnEvent, { once: true, passive: true });
    document.addEventListener('pointerdown', initGTMOnEvent, { once: true, passive: true });
    document.addEventListener('keydown', initGTMOnEvent, { once: true });

    const timeoutId = window.setTimeout(initGTM, 3000);

    return () => {
      window.clearTimeout(timeoutId);
      document.removeEventListener('scroll', initGTMOnEvent);
      document.removeEventListener('pointerdown', initGTMOnEvent);
      document.removeEventListener('keydown', initGTMOnEvent);
    };
  }, []);

  return null;
}
